/**********
 * Router *
 **********/

import { createRouter, createWebHistory } from 'vue-router';
import { setI18nLanguage, loadMessages } from '@/i18n';
import routes from './routes';


export function setupRouter(i18n)
{
    // ------------------------------------------------------------ CONSTRUCTOR

    const router = createRouter({
        history: createWebHistory(),
        base:    import.meta.env.VITE_API_LOCATION,
        routes,
    });

    // ------------------------------------------------------------ Language Guard

    router.beforeEach(async(to, from) =>
    {
        console.groupCollapsed('Guard: lang');

        let out = true;

        let locale = to.query.lang;

        if (locale && locale != 'undefined')
        {
            console.log(`Locale set from URL: "${locale}"`);

            if (locale != i18n.global.locale.value)
            {
                setI18nLanguage(i18n, locale);
            }

            const messages = i18n.global.getLocaleMessage(i18n.global.locale.value);

            // If there are no messages, load them
            if (!messages || !Object.entries(messages).length)
            {
                console.log('Loading messages…');
                await loadMessages(i18n, i18n.global.locale.value);
            }
        }
        else
        {
            // Get language from browser
            locale = typeof navigator.languages !== 'undefined' ? navigator.languages[0] : navigator.language || 'en';
            locale = locale.trim().split(/-|_/)[0];
            to.query.lang = locale;

            console.log(`Locale set from browser: "${locale}"`);

            // Redirect to the same URL with ?lang=locale
            out = {
                name:   to.name,
                params: to.params,
                query:  to.query,
            };

            console.log('Redirecting…', out);
        }


        console.groupEnd();

        return out;
    });

    return router;
};
